export const ITEMS_PER_COLUMN = 16;
export const COLUMN_WIDTH = 120;
export const COLUMN_GAP = 12;
export const PADDING_HORIZONTAL = COLUMN_GAP * 2;
export const MAX_COLUMNS_TO_SHOW = 3;

export const FilterVisibility = {
  BASIC: "Basic",
  ADVANCED: "Advanced",
  HIDDEN: "Hidden",
  HIDDEN_QUICK_FILTER: "Hidden_Quick_Filter",
  SYSTEM_HIDDEN: "System_Hidden"
};
